/**
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business ReactアプリのDOMエントリーポイント。Faro初期化後にReactルートをマウント
 * @graph-connects App [calls] ルートコンポーネント描画
 */

// Faro初期化は他のimportより前に実行
import { initializeFaro } from '@cortex/faro';
initializeFaro({ appName: 'quality-atelier' });

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './styles.css';

/** @graph-connects none */
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
